import React from "react"
import { Link } from "react-router-dom"
import { FormattedMessage } from 'react-intl'
import Container from 'react-bootstrap/Container'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import NavDropdown from 'react-bootstrap/NavDropdown'
import Image from "react-bootstrap/esm/Image"
import EventBus from "../../utils/EventBus"
import Spinner from "../spinners/Spinner"
import { Bank, BarChart, Building, Coin, Diagram3, DoorClosedFill, Folder, Gear, HandThumbsUp, House, People, PersonBadge, PiggyBank, FileText, Wallet, Receipt, CashStack, CreditCard, CardChecklist, GearWide } from "react-bootstrap-icons"

const TopNavBar = ({ currentUser }) => {

    const handleLogout = () => {
        EventBus.dispatch("logout")
    }

    if (!currentUser) {
        return <Spinner />
    }

    const menuItems = [
        { title: "navDashboard", titleDefault: "Dashboard", icon: <House />, path: "/dashboard" },        
        {
            title: "navReports", titleDefault: "Reports", icon: <BarChart />, submenus: [
                { title: "navGeneralReports", titleDefault: "General reports", icon: <FileText />, path: "/reports" },
                { title: "navProjectsReports", titleDefault: "Project reports", icon: <Diagram3 />, path: "/projectsReports" },
            ]
        },
        {
            title: "navManagement", titleDefault: "Management", icon: <Folder />, submenus: [
                { title: "navCustomers", titleDefault: "Customers", icon: <People />, path: "/customers" },
                { title: "navEntities", titleDefault: "Entities", icon: <Bank />, path: "/entities" },
                { title: "navPartners", titleDefault: "Partners", icon: <HandThumbsUp />, path: "/partners" },
                { title: "navProjects", titleDefault: "Projects", icon: <Diagram3 />, path: "/projects" },
                { title: "navProviders", titleDefault: "Providers", icon: <Building />, path: "/providers" },
                { title: "navUsers", titleDefault: "Users", icon: <PersonBadge />, path: "/users" }
            ]
        },
        {
            title: "navProjectedIncomes", titleDefault: "Projected Incomes", icon: <PiggyBank />, submenus: [
                { title: "navInvoices", titleDefault: "Customers Invoices", icon: <FileText />, path: "/invoices" },
                { title: "navProjectIncomes", titleDefault: "Project Incomes", icon: <Wallet />, path: "/incomes" },
            ]
        },
        {
            title: "navProjectedExpenses", titleDefault: "Projected Expenses", icon: <Coin />, submenus: [
                { title: "navExpensesGeneral", titleDefault: "General Expenses", icon: <CardChecklist />, path: "/expenses" },
                { title: "navExpensesProjects", titleDefault: "Projects Expenses", icon: <Receipt />, path: "/expensesProjects" },
                { title: "navPaymentsPartners", titleDefault: "Payments to Partners", icon: <CreditCard />, path: "/paymentsPartners" },
                { title: "navPayrolls", titleDefault: "Payrolls", icon: <CashStack />, path: "/payrolls" }
            ]
        },
        {
            title: currentUser?.name || "Profile", icon: <Gear />, submenus: [
                { title: "navProfile", titleDefault: "Profile", icon: <PersonBadge />, path: "/profile" },                
                ...(currentUser.role === "ADMIN" ? [{ title: "navConfig", titleDefault: "Config", icon: <GearWide />, path: "/config" }] : []),
                { title: "navLogout", titleDefault: "Logout", icon: <DoorClosedFill />, onClick: handleLogout }
            ]
        }
    ]

    return (
        <Container fluid className="p-0">
            <Navbar expand="lg" className="Login p-0">
                <Navbar.Brand><Image src="logo_profundis_378_80.png" width={200} /></Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto">
                        {menuItems.map((menu, index) => (
                            menu.submenus ? (
                                <NavDropdown title={
                                    menu.titleDefault ? (
                                        <>
                                            {menu.icon} <FormattedMessage id={menu.title} defaultMessage={menu.titleDefault} />
                                        </>
                                    ) : (
                                        <>
                                            {menu.icon} {menu.title}
                                        </>
                                    )
                                } id={"menu-dropdown-" + index} key={index}>
                                    {menu.submenus.map((submenu, idx) => (
                                        <NavDropdown.Item as={Link} to={submenu.path} onClick={submenu.onClick} key={idx} className="nav-link">
                                            {submenu.icon && submenu.icon} <FormattedMessage id={submenu.title} defaultMessage={submenu.title} />
                                        </NavDropdown.Item>
                                    ))}
                                </NavDropdown>
                            ) : (
                                <Link to={menu.path} className="nav-link" key={index}>
                                    {menu.icon} <FormattedMessage id={menu.title} defaultMessage={menu.title} />
                                </Link>
                            )
                        ))}
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </Container>
    )
}

export default TopNavBar
